import { createGlobalState } from 'react-hooks-global-state';

export const initialState = { 
    timeCDSpent: 0,
    timerIntTaskActive: {},
    openStopTask: false,
    appContext: null
};

export const { useGlobalState } = createGlobalState(initialState);